/* eslint-disable react/no-danger */
import React, { FC, useMemo, useState, useCallback, useRef, useEffect } from 'react';
import Rating from '../../atoms/Rating';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

const DisplayRating = ({
  data,
  fetchRating,
  showModal,
  onCloseHideSlider,
  setClickedProduct,
  isRating,
  getUpdatedRating,
  failedRatingHandler,
  pageType
}) => {
  const [productRating, setProductRating] = useState(0);
  const productRatings = isRating ? useState(true) : useState(false);
  const {
    brandName = '',
    brandTitle = '',
    deliveryDate = '',
    imageUrl = '',
    skuId = '',
    orderId,
    brickCode = ''
  } = data;

  const updateRating = value => {
    setProductRating(value);
  };
  const submitRating = async rating => {
    setProductRating(rating);
    const response = await fetchRating({
      sourcePage: 'PLP',
      skuData: skuId,
      rating,
      fetchSubRatingQuestion: true,
      fetchAggRating: false
    });
    showModal('rating-halfcard', {
      state: {
        deviceType: 'mobile',
        rating,
        pageToDisplay: 'ratingHalfCard',
        displayFeedBackPage: false,
        isfromWriteFeedBack: false, // if image then true
        isFeedBackSubmitted: true,
        isFromHomeWishList: true,
        sourcePage: pageType,
        pageName: pageType,
        pageType,
        productDetails: {
          brandName,
          description: brandTitle,
          imageUrl,
          productUrl: 'productUrl',
          productCode: skuId,
          skuId,
          optionCode: skuId,
          brickCode,
          orderId
        },
        onCloseCallback: onCloseHideSlider,
        ratingChangeHandler: updateRating, // call function to get updated rating value if it changed
        FeedBackSubmitFailedHandler: failedRatingHandler // set state in local, initial false
      }
    });
    setClickedProduct(skuId);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      page_name: pageType,
      page_type: pageType,
      product_name: brandName,
      product_id: skuId,
      product_brick: brickCode,
      order_id: orderId
    });
    // Segment Push Event
    segmentEventPush({
      event: 'Ratings Collected',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      screen_name: pageType,
      // page_type: pageType,
     // product_name: brandName,
      //product_id: skuId,
      // product_brick: brickCode,
      order_id: orderId,   
      rating_value: rating,
      products:[{
        product_id: brandName,
        product_name: skuId
      }],
      
    });
  };

  return (
    <>
      <Rating
        iconSize="lg"
        rating={productRating}
        onClickHandler={rating => submitRating(rating)}
      />
    </>
  );
};

export default DisplayRating;
